import { attribute, nullableSanitize } from '@/helper'

export default {
  attribute: attribute,
  nullableSanitize: nullableSanitize
}



// WEBPACK FOOTER //
// ./src/filters.js